import angular from 'angular';
import uiRouter from 'angular-ui-router';
import textFormElementComponent from './textFormElement.component';

let textFormElementModule = angular.module('textFormElement', [
  uiRouter
])

.component('textFormElement', textFormElementComponent)

.name;

export default textFormElementModule;
